import React from "react";
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '../../../../../tool'

import { templateConfig, reduxTemplateConfig } from './config';
import { Descriptions } from 'antd';
import ModalPlayer from '../../components/modalPlayer'

let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool
let { WizBrowserExport, WizButton, WizCard,WizGallery } = component_tool
let { Session } = utils_tool

const _getValue = (type, key) => {
  const values = {
    type: {
      1: '违法违规',
      2: '色情低俗',
      3: '诈骗信息',
      4: '低差广告',
      5: '虚假不实',
      6: '搬运抄袭',
      7: '谩骂攻击',
      8: '涉未成年人',
      9: '时政不实信息',
      10: '引人不适',
      11: '诱导关注点赞',
      12: '侵权投诉',
      999: '其他',
    },
  }
  return values[type][key]
}


class ShortVideoScreenRecordManager extends WizContainer {
  componentName = 'shortVideoScreenRecordManager'

  constructor(props) {
    super(props)
    const {history} = props
    let shortVideoInfo = {};
    let shortVideoState = 0;
    if (history.location && history.location.pathname === '/shortVideoScreen/record') {
      if (history.location && history.location.record) {
        shortVideoInfo = history.location.record
        shortVideoState = shortVideoInfo.state
        Session.set('shortVideoInfo', shortVideoInfo)
        Session.set('shortVideoState', shortVideoState)
      } else {
        shortVideoInfo = Session.get('shortVideoInfo') || {}
        shortVideoState = Session.get('shortVideoState') || 0
      }
      this.shortVideoInfo = shortVideoInfo
      this.shortVideoState = shortVideoState
      this.filters = {}
      this.state = {
        screenId: shortVideoInfo.id,
        shortVideoId: shortVideoInfo.shortVideoId,
        shortVideoState: shortVideoState,
        visible: false,
        videoUrl: '',
        imgVisible: false,
        imgs: []
      }
    }
  }

  _componentDidMount() {
    if (this.state && this.state.shortVideoId) {
      this.doAction({
        path: 'shortVideo/look',
        payload: {
          key: 'shortVideoInfo',
          apiParams: { id: this.state.shortVideoId }
        }
      })
    }
    this._getScreenRecordList();
  }

  _getScreenRecordList(apiParams = {}) {
    let { screenId, shortVideoId } = this.state
    this.doAction({
      path: 'shortVideoScreen/recordList',
      payload: {
        key: 'screenRecord@listByPage',
        apiParams: {
          screenId: screenId,
          shortVideoId: shortVideoId,
          ...apiParams
        }
      }
    })
  }


  propsAndStateOnChange = {
    shortVideoInfo: this._getShortVideoInfoOver.bind(this),
  }

  _getShortVideoInfoOver(nextProps, nextState) {
    let { shortVideoInfo } = nextProps
    if (shortVideoInfo['success']) {
      this.shortVideoInfo = shortVideoInfo['data']
      nextState['screenId'] = shortVideoInfo['data']['screenId'] || 0
    } else {
      wizNotice.error(shortVideoInfo['msg'] || '获取数据失败，请稍后再试')
    }
    return true
  }


  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '举报人',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '举报人账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '举报时间',
        field: 'operationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '举报类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '举报描述',
        field: 'remark',
        width: 100,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]

    if (o['success']) {
      let data = o['data']
      let shortVideo = data['shortVideo']
      let list = data['list']
      list && list.forEach(e => {
        e['type'] = _getValue('type', e['type'])
      })

      let labelIds = []
      shortVideo['labelIds'] && shortVideo['labelIds'].length && shortVideo['labelIds'].forEach(item => {
        labelIds.push(item.name)
      })
      shortVideo['labelIds'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

      let str = '标题：' + shortVideo['title'] + '\n'
        + '标签：' + shortVideo['labelIds'] + '\n'
        + '发布人：' + shortVideo['fullName'] + '\n'
        + '发布时间：' + shortVideo['releaseTime']

      WizBrowserExport({
        title: str,
        sheetName: '举报记录',
        columns: columnDefs.filter((_, index) => index),
        rows: list,
        filename: '举报记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  // 查看图片
  _handleLook = (files) => {
    let splitFiles = files.split(',')
    let imgsPath = splitFiles.map(e => getOssFilePath(e))
    this.setState({
      imgs: imgsPath,
      imgVisible: true
    })
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig(this._handleLook,{ screenId: this.state.screenId, shortVideoId: this.state.shortVideoId,shortVideoState:this.shortVideoState }),
      apiDataFormat: {
        export: this._handleFile,
      },
      screenId: this.state.screenId,
      shortVideoId: this.state.shortVideoId
    })
    const items = this.shortVideoInfo
    let labelIds = []
    items['labelIds'] && items['labelIds'].length && items['labelIds'].forEach(item => {
      labelIds.push(item.name)
    })
    items['labelNames'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

    let { visible, videoUrl, imgs, imgVisible } = this.state
    const modalProps = {
      visible,
      videoUrl,
      setVisible: ()=> this.setState({ visible: false, videoUrl: '' })
    }

    return (
      <React.Fragment>
        <WizCard title={'基础信息'}>
          <Descriptions column={2} style={{ paddingLeft: 25 }}>
            <Descriptions.Item label='标题'>
              <>
                <span style={{ marginRight: 10 }}>{items.title}</span>
                <WizButton type='primary' shape='round' size='small' onClick={() => this.setState({ visible: true, videoUrl: items.video })} >
                  播放
                </WizButton>
              </>
            </Descriptions.Item>
            <Descriptions.Item label='标签'>{items.labelNames}</Descriptions.Item>
            <Descriptions.Item label='发布人'>{items.fullName}</Descriptions.Item>
            <Descriptions.Item label='发布时间'>{items.releaseTime}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        <WizCard title={'举报记录'}>
          <WizReduxTemplate {..._reduxTemplateConfig} />
        </WizCard>
        <ModalPlayer {...modalProps} />
        <WizGallery
          visible={imgVisible}
          sources={imgs}
          index={0}
          onCancel={() => this.setState({ imgVisible: false, imgs: [] })}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let { shortVideo, shortVideoScreen } = state
  const shortVideoInfo = modelUtils.getModelEntity(shortVideo, 'shortVideoInfo');
  const recordList = modelUtils.getModelEntity(shortVideoScreen, 'screenRecord@listByPage')
  const load = modelUtils.getLoadingState(state, 'shortVideoScreen')
  return {
    shortVideoInfo,
    recordList,
    ...load
  }
};

export default connect(mapStateToProps)(ShortVideoScreenRecordManager);
